module.exports = __webpack_public_path__ + "static/media/bg_2.6da8b6a1.png";